import { Illustration, Text, Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";

interface Props {
  onComplete: () => void;
}

export function ClipboardOrientationPassed(props: Props) {
  const { onComplete } = props;

  return (
    <Stack justifyContent="space-between" height="100%" spacing={4}>
      <Stack alignItems="center" spacing={8} flex={1} px={6} pt={12}>
        <Illustration type="shift-booked" />
        <Stack spacing={4}>
          <Title variant="h3" component="h2" align="center">
            Demo Shift complete!
          </Title>
          <Text
            light
            align="center"
            sx={{
              lineHeight: 1.25,
            }}
          >
            Get ready to pick up shifts!
          </Text>
        </Stack>
      </Stack>

      <Button
        onClick={() => {
          onComplete();
        }}
      >
        Continue
      </Button>
    </Stack>
  );
}
